<template>
    <v-timeline align-top dense>
        <div class="timeline-wrap" v-for="(item, index) in items" :key="index">
            <v-timeline-item v-if="item.step === step" color="pink" small class="current"><p>{{ item.title }}</p></v-timeline-item>
            <v-timeline-item v-else-if="item.step > step" color="grey"  class="after" small><p>{{ item.title }}</p></v-timeline-item>
            <v-timeline-item v-else color="pink" small><p>{{ item.title }}</p></v-timeline-item>
        </div>
    </v-timeline>
</template>

<script>
    export default {
        props: ['step'],
        data: () => ({
            items: [
                { step: 1, title: '1.テンプレート一覧' },
                { step: 2, title: '2.CSVインポート' },
            ],
        }),
    };
</script>
